import React, { Component } from "react";
import CartContext from "./CartContext";
import { SideMenu } from "./SideMenu";
import { BiRefresh } from "react-icons/bi";
import { BsFillPencilFill } from "react-icons/bs";
import { MessageBox } from "./MessageBox";
import { LoadSpinner } from "./LoadSpinner";

import {
  OverlayTrigger,
  Tabs,
  Tab,
  Tooltip,
  Button,
  ButtonToolbar,
  Form,
  Row,
  Col,
  Modal,
  Nav,
  Table,
  Navbar,
} from "react-bootstrap";

export class RawMaterialManufacturingRequest extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      rawMaterialsInventory: [],
      rawmaterialmanufacturingrequest: [],
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      reload: true,
      firstload: false,
      rawmaterialwarehouse: [],
      users: [],
    };
  }
  GetRawMaterialsInventories = () => {
    fetch(
      process.env.REACT_APP_API +
        "Rawmaterials/GetRawMaterialsInventories/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ rawMaterialsInventory: data }, () => {
            this.setState({ reload: false }, () => {
              this.setState({ reload: true });
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };
  GetUsers = () => {
    const config = {
      headers: { Authorization: `Bearer ${this.context.userData.bearertoken}` },
    };
    fetch(
      process.env.REACT_APP_API +
        "AdminUsers/GetStoreUserAccounts/" +
        this.context.storeId
      // config
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({
            //users: data.filter((f) => f.storeRoleId != 1),
            users: data,
          });
        }
      })
      .catch((error) => {
        alert("Session Timeout! Signout and Signin again!");
      });
  };
  GetRawMaterialWarehouses = () => {
    fetch(
      process.env.REACT_APP_API +
        "Warehouse/GetRawMaterialWarehouses/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ rawmaterialwarehouse: data }, () => {
            this.setState({ reload: false }, () => {
              this.setState({ reload: true });
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };
  GetRawMaterialManufacturingRequest = () => {
    fetch(
      process.env.REACT_APP_API +
        "Manufacturing/GetRawMaterialManufacturingRequest/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ rawmaterialmanufacturingrequest: data }, () => {
            this.setState({ reload: false }, () => {
              this.setState({ reload: true });
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  OnSaved = () => {
    this.OnRefreshButtonClick();
  };
  OnDeleted = () => {
    this.OnRefreshButtonClick();
  };

  OnRefreshButtonClick = () => {
    this.setState({ rawmaterialmanufacturingrequest: [] }, () => {
      this.GetRawMaterialManufacturingRequest();
    });
    this.setState({ rawMaterialsInventory: [] }, () => {
      this.GetRawMaterialsInventories();
    });
  };

  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };

  OnUpdated = (indexno) => {
    this.OnRefreshButtonClick();
  };

  addModalClose = () => {
    this.setState({ addModalShow: false }, () => {});
    this.OnRefreshButtonClick();
  };

  componentDidMount = () => {
    window.scrollTo(0, 0);
    if (this.state.firstload == false) {
      this.state.firstload = true;
      this.GetUsers();
      this.GetRawMaterialWarehouses();
      this.GetRawMaterialsInventories();
      this.GetRawMaterialManufacturingRequest();
    }
    document.addEventListener("keydown", (event) => {
      if (event.key == "F9") {
        this.OnRefreshButtonClick();
      }
    });
  };

  render() {
    return (
      <>
        <div className="Container-fluid p-0 ">
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          <Navbar className="shadow position-sticky fixed-top py-3 text-black ">
            <h3> Production Requests &nbsp;</h3>
            <Navbar.Collapse className="justify-content-end mx-0 ">
              <Nav>
                <ButtonToolbar className="text-end align-middle">
                  <Button
                    className="mainthemecolor"
                    size=""
                    onClick={() => this.OnRefreshButtonClick()}
                  >
                    <BiRefresh size="26"></BiRefresh>
                    Refresh(F9)
                  </Button>
                </ButtonToolbar>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
          <div className="purposestyle p-2 ">
            {" "}
            <b>Purpose:</b> Use this module to manage all Production requests.
            Requests are created by Production Unit or you can create a request
            manually. You can also edit the request and change the status of the
            request.
          </div>
          <div className="p-1 m-1 border-0 border-secondary bg-light">
            <Tabs
              id="controlled-tab-example"
              activeKey={this.state.key}
              onSelect={(k) => this.setState({ key: k })}
              className="bg-light "
              variant="tabs"
              fill
              style={{ fontSize: "16px" }}
            >
              <Tab
                eventKey="Request"
                title={
                  "1.New Request (" +
                  this.state.rawmaterialmanufacturingrequest.filter(
                    (f) => f.statusId == 1
                  ).length +
                  ")"
                }
                className=""
              >
                <RawMaterialManufacturingRequestTable
                  status="1"
                  rawmaterialmanufacturingrequest={
                    this.state.rawmaterialmanufacturingrequest
                  }
                  rawmaterialwarehouse={this.state.rawmaterialwarehouse}
                  rawMaterialsInventory={this.state.rawMaterialsInventory}
                  users={this.state.users}
                  OnDeleted={this.OnDeleted}
                  Refresh={this.OnRefreshButtonClick}
                ></RawMaterialManufacturingRequestTable>
              </Tab>
              <Tab
                eventKey="Delivered"
                title={
                  "2.Delivered (" +
                  this.state.rawmaterialmanufacturingrequest.filter(
                    (f) => f.statusId == 2
                  ).length +
                  ")"
                }
                className=""
              >
                <RawMaterialManufacturingRequestTable
                  status="2"
                  rawmaterialmanufacturingrequest={
                    this.state.rawmaterialmanufacturingrequest
                  }
                  rawMaterialsInventory={this.state.rawMaterialsInventory}
                  rawmaterialwarehouse={this.state.rawmaterialwarehouse}
                  users={this.state.users}
                  OnDeleted={this.OnDeleted}
                  Refresh={this.OnRefreshButtonClick}
                ></RawMaterialManufacturingRequestTable>
              </Tab>
              <Tab
                eventKey="OutOfStock"
                title={
                  "3.OutOfStock (" +
                  this.state.rawmaterialmanufacturingrequest.filter(
                    (f) => f.statusId == 3
                  ).length +
                  ")"
                }
                className=""
              >
                <RawMaterialManufacturingRequestTable
                  status="3"
                  rawmaterialmanufacturingrequest={
                    this.state.rawmaterialmanufacturingrequest
                  }
                  rawMaterialsInventory={this.state.rawMaterialsInventory}
                  rawmaterialwarehouse={this.state.rawmaterialwarehouse}
                  users={this.state.users}
                  OnDeleted={this.OnDeleted}
                  Refresh={this.OnRefreshButtonClick}
                ></RawMaterialManufacturingRequestTable>
              </Tab>
              <Tab
                eventKey="Returned"
                title={
                  "4.Returned (" +
                  this.state.rawmaterialmanufacturingrequest.filter(
                    (f) => f.statusId == 4
                  ).length +
                  ")"
                }
                className=""
              >
                <RawMaterialManufacturingRequestTable
                  status="4"
                  rawmaterialmanufacturingrequest={
                    this.state.rawmaterialmanufacturingrequest
                  }
                  rawMaterialsInventory={this.state.rawMaterialsInventory}
                  rawmaterialwarehouse={this.state.rawmaterialwarehouse}
                  users={this.state.users}
                  OnDeleted={this.OnDeleted}
                  Refresh={this.OnRefreshButtonClick}
                ></RawMaterialManufacturingRequestTable>
              </Tab>
            </Tabs>
          </div>
        </div>
      </>
    );
  }
}

export class RawMaterialManufacturingRequestTable extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Table border striped className="px-0 bg-white ">
          {window.innerWidth > 900 ? (
            <>
              <thead className="">
                <tr className="text-center text-black bg-white border">
                  <th></th>
                  <th width="5%">PmrNo</th>
                  <th className="text-start" width="20%">
                    RawMaterial Name
                  </th>
                  <th width="10%">In-stock (Current)</th>
                  <th width="10%">Requested Qty/WT</th>
                  <th width="5%">Unit</th>
                  <th width="10%">Price Per Unit</th>
                  <th width="10%">S.Total</th>
                  <th width="10%">WareHouse</th>
                  <th width="10%">RequestedBy</th>
                  <th width="10%">Status</th>
                  <th width="5%" className="text-end">
                    Options
                  </th>
                </tr>
              </thead>
            </>
          ) : (
            <></>
          )}

          <tbody className="text-primary border">
            {this.props.rawmaterialmanufacturingrequest
              .filter((f) => f.statusId == this.props.status)
              .sort((a, b) => (a.created > b.created ? 1 : -1))
              .map((request, i) => (
                <EditManufacturingRequestInline
                  key={request.id || i}
                  index={i}
                  request={request}
                  OnDeleted={this.props.OnDeleted}
                  Refresh={this.props.Refresh}
                  rawmaterialwarehouse={this.props.rawmaterialwarehouse}
                  rawMaterialsInventory={this.props.rawMaterialsInventory}
                  users={this.props.users}
                />
              ))}
          </tbody>
        </Table>
      </>
    );
  }
}

export class EditManufacturingRequestInline extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      manufacturingrequest: "",
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
      editModalShow: false,
    };
  }

  GetUserNameById = (id) => {
    var result = this.props.users.filter((f) => f.id == id);
    if (result.length > 0) return result[0].emailId;
    else return "";
  };
  GetWarehouseName = (id) => {
    var result = this.props.rawmaterialwarehouse.filter((f) => f.id == id);
    if (result.length > 0) return result[0].name;
    return "";
  };

  ShowMessagBox = (title, message) => {
    this.setState({
      msgboxOpen: true,
      msgboxTitle: title,
      msgboxMessage: message,
    });
  };
  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  OnDelete = () => {
    if (this.state.manufacturingrequest.id == undefined) {
      this.ShowMessagBox(
        "Information",
        "This is invalid row which can't be deleted. Press Refresh!"
      );
      return;
    }

    this.ShowLoadSpinner();
    const requestOptions = {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    };

    fetch(
      process.env.REACT_APP_API +
        "StoreManager/DeleteRawMaterialManufacturingRequest/" +
        this.state.manufacturingrequest.id,
      requestOptions
    )
      .then((res) => {
        if (res.status != 200) {
          this.HideLoadSpinner();
          alert(
            "Not deleted. This ManufacturingRequest may be associated with few Products. First disassociate this manufacturingrequest from the Products and then try!"
          );
          return;
        }
        this.HideLoadSpinner();
        this.ShowMessagBox(
          "Status",
          "Deleted Successfully. Click Refresh Button to see the changes!"
        );
        this.props.OnDeleted();
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("OnDelete Failed" + error);
      });
  };

  componentDidMount = () => {
    this.setState({ manufacturingrequest: this.props.request });
  };
  OnEditButtonClick = (e) => {
    // optional: stopPropagation if called from a button
    if (e && e.stopPropagation) e.stopPropagation();
    this.setState({ editModalShow: true }, () => {});
  };

  editModalClose = () => {
    this.setState({ editModalShow: false }, () => {});
    this.props.Refresh();
  };

  GetRawMaterNameById = (id) => {
    var r = this.context.rawMaterialsInventory.filter((f) => f.id == id);
    if (r.length > 0) return r[0].name;

    return "";
  };
  GetInStockOfRM = () => {
    var r = this.props.rawMaterialsInventory.filter(
      (f) => f.id == this.props.request.rawMaterialId
    );
    if (r.length > 0) {
      return r[0].instock;
    }
    return 0;
  };

  render() {
    const req = this.props.request;
    const idx = this.props.index || 0;

    return (
      <>
        {this.state.editModalShow === true ? (
          <ManufacturingRequestAddOrEditModal
            show={this.state.editModalShow}
            onHide={this.editModalClose}
            request={this.props.request}
            Type="Edit"
            rawmaterialwarehouse={this.props.rawmaterialwarehouse}
            rawMaterialsInventory={this.props.rawMaterialsInventory}
            users={this.props.users}
          />
        ) : (
          ""
        )}
        {this.state.loadSpinnerOpen === true ? <LoadSpinner open="true" /> : ""}

        {/*
          DESKTOP ROW (unchanged)
        */}
        <tr
          className="d-none d-md-table-row text-center align-middle text-secondary bg-white mx-5"
          style={{ fontSize: "12px" }}
        >
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          <td>{idx + 1}</td>
          <td>{req.pmrNo}</td>
          <td className="text-start">
            {req.rawMaterialName /* kept as provided */}
          </td>
          <td>
            <span className="text-primary">{this.GetInStockOfRM()}</span>
          </td>
          <td>
            <span className="text-danger ">{req.qty.toFixed(2)}</span>
          </td>
          <td>{req.unit}</td>
          <td>{req.price}</td>
          <td>{req.price * req.qty}</td>
          <td>{this.GetWarehouseName(req.warehouseId)}</td>
          <td>{this.GetUserNameById(req.assignedTo)}</td>
          <td>
            {req.statusId == 1
              ? "Requested"
              : req.statusId == 2
              ? "Delivered"
              : req.statusId == 3
              ? "OutOfStock"
              : req.statusId == 4
              ? "Returned"
              : ""}
          </td>

          <td className="col-md-2 text-end align-middle ">
            <div className="btn-group">
              <OverlayTrigger overlay={<Tooltip>Edit!</Tooltip>}>
                <Button
                  className="rounded-circle"
                  variant="warning"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.OnEditButtonClick(e);
                  }}
                >
                  <BsFillPencilFill size="16" />
                </Button>
              </OverlayTrigger>
            </div>
          </td>
        </tr>

        {/*
          MOBILE ROW: visible only on small screens
          Uses CSS grid to keep three columns aligned and compact.
        */}
        <tr
          className="d-table-row d-md-none text-start bg-white"
          style={{ fontSize: "12px" }}
        >
          <td colSpan="99" style={{ padding: 8 }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "8px 12px",
                alignItems: "start",
              }}
              // Row click opens edit, same behaviour as your desktop row
              onClick={(e) => {
                this.OnEditButtonClick && this.OnEditButtonClick(e);
              }}
              role="button"
            >
              {/* column 1 */}
              <div style={{ gridColumn: "1 / 2" }}>
                <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 6 }}>
                  {idx + 1}. {req.rawMaterialName}
                </div>

                <div style={{ marginBottom: 6 }}>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>PmrNo</div>
                  <div>{req.pmrNo}</div>
                </div>

                <div style={{ marginBottom: 6 }}>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>In-stock</div>
                  <div className="text-primary">{this.GetInStockOfRM()}</div>
                </div>

                <div style={{ marginBottom: 6 }}>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>Requested</div>
                  <div className="text-danger">{req.qty.toFixed(2)}</div>
                </div>
              </div>

              {/* column 2 */}
              <div style={{ gridColumn: "2 / 3" }}>
                <div style={{ marginBottom: 6 }}>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>Unit</div>
                  <div>{req.unit}</div>
                </div>

                <div style={{ marginBottom: 6 }}>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>
                    Price / Unit
                  </div>
                  <div>{req.price}</div>
                </div>

                <div style={{ marginBottom: 6 }}>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>S.Total</div>
                  <div>{req.price * req.qty}</div>
                </div>

                <div style={{ marginBottom: 6 }}>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>Warehouse</div>
                  <div>{this.GetWarehouseName(req.warehouseId)}</div>
                </div>
              </div>

              {/* column 3 */}
              <div style={{ gridColumn: "3 / 4" }}>
                <div style={{ marginBottom: 6 }}>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>
                    Requested By
                  </div>
                  <div>{this.GetUserNameById(req.assignedTo)}</div>
                </div>

                <div style={{ marginBottom: 6 }}>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>Status</div>
                  <div>
                    {req.statusId == 1
                      ? "Requested"
                      : req.statusId == 2
                      ? "Delivered"
                      : req.statusId == 3
                      ? "OutOfStock"
                      : req.statusId == 4
                      ? "Returned"
                      : ""}
                  </div>
                </div>

                {/* actions */}
                <div
                  style={{
                    marginTop: 8,
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 8,
                  }}
                >
                  <OverlayTrigger overlay={<Tooltip>Edit!</Tooltip>}>
                    <Button
                      size="sm"
                      className="rounded-circle p-1"
                      variant="warning"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.OnEditButtonClick(e);
                      }}
                    >
                      <BsFillPencilFill size="14" />
                    </Button>
                  </OverlayTrigger>

                  <OverlayTrigger overlay={<Tooltip>Delete</Tooltip>}>
                    <Button
                      size="sm"
                      className="rounded-circle p-1"
                      variant="danger"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (
                          window.confirm("Are you sure you want to delete?")
                        ) {
                          this.OnDelete();
                        }
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        fill="currentColor"
                        className="bi bi-trash"
                        viewBox="0 0 16 16"
                      >
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                        <path
                          fillRule="evenodd"
                          d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                        />
                      </svg>
                    </Button>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </>
    );
  }
}

export class ManufacturingRequestAddOrEditModal extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);

    this.state = {
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
      statusId: this.props.request.statusId,
    };
  }

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
    this.props.onHide();
  };
  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };
  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  UpdateRawMaterialsManufacturingRequest = () => {
    this.ShowLoadSpinner();
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      // body: JSON.stringify(tmpManufacturingRequest),
    };

    fetch(
      process.env.REACT_APP_API +
        "Manufacturing/UpdateRawMaterialsManufacturingRequest/" +
        this.props.request.id +
        "/" +
        this.state.statusId,
      requestOptions
    )
      .then((res) => {
        if (res.status == 200) {
          this.HideLoadSpinner();
          this.props.onHide();
          return;
        }
        this.HideLoadSpinner();
        alert("This ManufacturingRequest is already exist. try again!");
        return;
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("Exception. Received an Exception. Try after sometime !" + error);
      });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.UpdateRawMaterialsManufacturingRequest();
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;

    switch (name.trim()) {
      case "statusId":
        this.setState({ statusId: value });
        break;
    }
  };
  GetUserNameById = (id) => {
    var result = this.props.users.filter((f) => f.id == id);
    if (result.length > 0) return result[0].emailId;
    else return "";
  };
  GetWarehouseName = (id) => {
    var result = this.props.rawmaterialwarehouse.filter((f) => f.id == id);
    if (result.length > 0) return result[0].name;
    return "";
  };

  componentDidMount() {
    if (this.props.Type == "Edit") {
      this.setState({ manufacturingrequest: this.props.manufacturingrequest });
    }
  }
  GetInStockOfRM = () => {
    var r = this.props.rawMaterialsInventory.filter(
      (f) => f.id == this.props.request.rawMaterialId
    );
    if (r.length > 0) {
      return r[0].instock;
    }
    return 0;
  };

  render() {
    return (
      <div className="container ">
        <Modal
          {...this.props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          keyboard={false}
          dialogClassName="ManufacturingRequestModal"
        >
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          {this.state.loadSpinnerOpen === true ? (
            <LoadSpinner open="true"></LoadSpinner>
          ) : (
            ""
          )}
          <Form onSubmit={this.handleSubmit}>
            <Modal.Header closeButton className="bg-warning">
              <Modal.Title id="contained-modal-title-vcenter">
                {this.props.Type == "Edit"
                  ? "Manufacturing Request"
                  : "Add Manufacturing Request"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="show-grid ">
              <Row
                className="m-2 p-2 bg-light border"
                style={{ fontSize: "12pt" }}
              >
                <Col md={12}>
                  <h4>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="4">
                        PMR No:
                      </Form.Label>
                      <Col sm="8">{this.props.request.pmrNo}</Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="4">
                        RawMaterial Name:
                      </Form.Label>
                      <Col sm="8">
                        <span className="bg-primary text-white fs-3">
                          {this.props.request.rawMaterialName}
                        </span>
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="4">
                        InStock Qty/WT:
                      </Form.Label>
                      <Col sm="8">
                        <span className="bg-primary text-white fs-3">
                          {this.GetInStockOfRM(
                            this.props.request.rawMaterialId
                          )}{" "}
                          {this.props.request.unit}
                        </span>
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="4">
                        Requested Qty/WT:
                      </Form.Label>
                      <Col sm="8">
                        <span className="bg-danger text-white fs-3">
                          {this.props.request.qty}&nbsp;{" "}
                          {this.props.request.unit}
                        </span>
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="4">
                        Price:
                      </Form.Label>
                      <Col sm="8">{this.props.request.price}</Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="4">
                        Sub.Total:
                      </Form.Label>
                      <Col sm="8">
                        {this.props.request.price * this.props.request.qty}
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="4">
                        Details:
                      </Form.Label>
                      <Col sm="8">{this.props.request.details}</Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="4">
                        WareHouse:
                      </Form.Label>
                      <Col sm="8">
                        {this.GetWarehouseName(this.props.request.warehouseId)}
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="4">
                        RequestedBy:
                      </Form.Label>
                      <Col sm="8">
                        {this.GetUserNameById(this.props.request.assignedTo)}
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="4">
                        Status:
                      </Form.Label>
                      <Col sm="8">
                        <Form.Select
                          type="text"
                          size="lg"
                          className="pd-2 w-100"
                          name="statusId"
                          required
                          value={this.state.statusId}
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        >
                          {this.props.request.statusId == 1 &&
                          this.GetInStockOfRM(
                            this.props.request.rawMaterialId
                          ) >= this.props.request.qty ? (
                            <>
                              <option value="1">Requested</option>
                              <option value="2">Delivered</option>
                              <option value="3">OutOfStock/Cancelled</option>
                            </>
                          ) : this.props.request.statusId == 1 &&
                            this.GetInStockOfRM(
                              this.props.request.rawMaterialId
                            ) < this.props.request.qty ? (
                            <>
                              <option value="1">Requested</option>
                              <option value="3">OutOfStock/Cancelled</option>
                            </>
                          ) : (
                            <></>
                          )}
                          {this.props.request.statusId == 2 ? (
                            <>
                              <option value="2">Delivered</option>
                              <option value="4">Returned</option>
                            </>
                          ) : (
                            <></>
                          )}
                          {this.state.statusId == 4 ? (
                            <>
                              <option value="4">Returned</option>
                            </>
                          ) : (
                            <></>
                          )}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </h4>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer className="bg-light">
              <Form.Group>
                <Button variant="primary" size="lg" type="submit">
                  Save
                </Button>
              </Form.Group>

              <Button variant="danger" size="lg" onClick={this.props.onHide}>
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}
